<template>
  <div>
      <div v-for="item in keysList" :key="item">      
        <a-row>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="功能名称">
              <a-input
                :allowClear="true"
                placeholder="请输入功能名称"
                v-decorator="[
                    `name[${item}]`, 
                    { 
                      initialValue:arr[item] ? arr[item].name : undefined ,
                      rules: [{ required: true, message: '请输入功能名称' }] 
                    }
                  ]"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :labelCol="labelCol3" :wrapperCol="wrapperCol3" label="成本价">
              <a-input
                :allowClear="true"
                placeholder="请输入成本价"
                v-decorator="[
                    `costPrice[${item}]`, 
                    { 
                      initialValue:arr[item] ? arr[item].costPrice : undefined ,
                      rules: [{ required: false, message: '请输入成本价' }] 
                    }
                  ]"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="2">
            <a-form-item style="float: right; margin-right: 32px">
              <a-button @click="removeRow(item)">删除</a-button>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item
              label="功能描述"
              :labelCol="labelCol2"
              :wrapperCol="wrapperCol2"
            >
              <zm-editor 
                :height="76"  
                v-model="descriptionArr[item]"
              ></zm-editor>
            </a-form-item>
          </a-col>
        </a-row>
      </div>
      <a-row type="flex" justify="center">
        <a-col :span="2">
          <a-button type="primary" icon="plus" @click="addRow">添加</a-button>
        </a-col>
      </a-row>
    </div>
</template>

<script>
export default {
  props: {
    arr: {
      type: Array,
      default: function () {
        return []
      }
    },
    form:[Object],
    type:[String]
  },
  data () {
    return {
      id: 0,
      keysList: [],
      model:{},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      labelCol3: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
      colSpan: 6,
      descriptionArr:['']
    }
  },
  created () {
    this.init()
  },
  methods: {
    getData(){
      const arr = []
      this.keysList.forEach(item => {
        const data = {
          name: this.form.getFieldValue(`name[${item}]`),
          costPrice: this.form.getFieldValue(`costPrice[${item}]`),
          description: this.descriptionArr[item],
        }
        console.log('loop',item,data);
        if(data.description === ''){
          delete data.description
        }

        arr.push(data)
      })
      return arr
    },
    // 初始化
    init () {
      this.keysList = []
      this.model = {}
      this.id = 0
      if(this.type === this.$sysInfo.MODAL_ADD){
        this.descriptionArr = ['']
      }else{
        this.descriptionArr = this.arr.map(item => item.description)
      }
      const arr = [0]
      if (this.arr.length !== 0) {
        for (let i = 1; i < (this.arr).length; i++) {
          arr.push(i)
          this.id = this.id + 1
        }
      }
      this.keysList = arr
      console.log('arr',this.arr);
      console.log('init',this.keysList);

    },
    // 移除某行
    removeRow (k) {
      if (this.keysList.length === 1) { // 如果存在可以移除所有行的情况，把条件改为this.keysList.length === 0即可
        this.clear(k)
        return
      }
      this.keysList = this.keysList.filter(item => item !== k)
      console.log('del',this.keysList);
    },
    // 新增一行
    addRow () {
      this.id = this.id + 1
      this.keysList = this.keysList.concat(this.id)
      console.log('add',this.keysList);
    },
    clear(item){
      let nameArr = this.form.getFieldValue('name')
      nameArr[item] = ''
      let costPriceArr = this.form.getFieldValue('costPrice')
      costPriceArr[item] = ''
      this.form.setFieldsValue({
        name:nameArr,
        costPrice:costPriceArr,
      })
      this.description = ''
    }
  }
}
</script>

<style lang="less" scoped>

</style>

